<template>
    <v-container fluid class="pt-0">
        <v-row align="center" justify="center" >
            <v-col cols="12" sm="12" md="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        Edit Type
                        <div class="flex-grow-1"></div>
                        <!-- <v-btn color="primary" @click="$router.push('/idtypelist')">ID Type List</v-btn> -->
                    </v-card-title>

                    <v-card-text>
                         <v-divider></v-divider>
                        <v-form v-model="valid" enctype="multipart/form-data" id="createcategory">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <h4 class="title">Type Information</h4>
                                    </v-col>
                                </v-row>
                                
                                 <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                        v-model="data.name"
                                        name="name"
                                        label="Type Name"
                                        required
                                        v-validate="'required|max:255'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                        ></v-text-field>
                                    </v-col>
                                    
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="12" md="12" >
                                        Description

                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="12" md="12" >
                                        <editor
                                        api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                        initialValue=""
                                        v-model="data.description"
                                        :init="editorConfigDescription"
                                        ></editor>
                                    </v-col>
                                </v-row>
                                 
                                  
                                 
                               
                                <v-divider></v-divider>
                                <div class="my-3">
                                <v-btn color="primary" @click="submit">Save</v-btn>
                                </div>
                            </v-container>
                        </v-form>
                    </v-card-text>


                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>
<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";
    import { Cropper } from 'vue-advanced-cropper'
    import Editor from '@tinymce/tinymce-vue'


    Vue.use(VeeValidate);
    export default
    {

        props: 
        {
            source: String
        },
        data: () => 
        ({
            editorData: '',
            editorConfigDescription: {height: 200,
                menubar: false,
                //  plugins: [
                //    'advlist autolink lists link image charmap print preview anchor',
                //    'searchreplace visualblocks code fullscreen',
                //    'insertdatetime media table paste code wordcount autoresize'
                //  ],
                // toolbar:' bold italic | alignleft aligncenter alignright alignjustify'
                toolbar: 'undo redo | styleselect | cut copy paste| bold italic | alignleft aligncenter alignright alignjustify | outdent indent'

            },
            valid: true,
            name:"",
            business_id:0,
            id:0,
            data:[],
            dictionary: 
            {
                attributes: {
                    name: "Type Name",
                },
                custom: {}
            },

        }),
        components: 
        {
            'editor': Editor,

            Cropper
        },
        mounted() 
        {
            this.$validator.localize("en", this.dictionary);
        },
        created() 
        {
            
            this.storeBusiness=JSON.parse(localStorage.getItem('business'));

            this.business_id=this.storeBusiness.id;

            if (this.$route.params.id) {
            this.id = this.$route.params.id;
            }
            this.fetchdata();

            
        },
        methods: 
        {
            fetchdata() 
            {
                this.$http
                .get(this.$apidomain+"typeDatapwa/" + this.id)
                .then(res => {
                    this.data=res.data.type;
                
                

                })
                .catch(err => {
                console.log(err.response);
                });
            },
            submit() {
                let th = this;
                if (this.$validator.validateAll()) {
                    let fd = new FormData(document.getElementById("createcategory"));

                    
                    fd.append('businesses_id',this.business_id);

                    fd.append('description',this.data.description);
                    


                    this.$http
                    .post(this.$apidomain+"edittypepwa/"+this.id, fd)
                    .then(res => {
                        if(res.data.success)  
                        {
                        
                            // this.$router.push({name:'categorylist'});
                            this.$router.push({name:'typelist'});


                            // this.fetchdata();
                            
                        //this.$router.push("/courselist");
                        }  
                        else
                        {
                            let errmsg=[];
                            for(var prop in res.data.errors){
                                errmsg.push(res.data.errors[prop][0]);
                            }
                            //alert(errmsg[0]);
                        }
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            }

        }
    }
</script>
